import { Menu, MenuTheme } from 'antd';
import { MenuMode } from 'rc-menu/lib/interface';
import { Link, generatePath, matchRoutes, useLocation, useParams } from 'react-router-dom';


export interface PageLayoutProps {
  path: string;
  title: string;
  icon: React.JSX.Element;
  id: string | number;
  parent?: string;
}
interface TextProp {
  pageLayouts: PageLayoutProps[];
  theme: MenuTheme | undefined;
  mode: MenuMode | undefined;
  isReplacingCurrentRoute?: boolean;
}

export const MenuComponent = ({ pageLayouts, ...props }: TextProp) => {
  const params = useParams();
  const location = useLocation();

  const createPath = (path: string): string => {
    return generatePath(path.replace('*', ''), params);
  };

  const buildMenuItems = (parentId: string | number): any[] => {
    const children = pageLayouts.filter((x) => x.parent === parentId);
    if (!children) return [];

    return children.map((x: any) => {
      let child = pageLayouts.find((y: any) => y.id === x.id) as any;
      let grandChildren = pageLayouts.filter((x: any) => x.parent === child.id);
      
      return grandChildren && grandChildren.length > 0 ? 
      {
            key: child.id,
            label: child.title,
            icon: child.icon,
            children: [
              {
                key: `${child.id}-link`,
                label: <Link replace={props.isReplacingCurrentRoute} to={createPath(child.path)}>{child.title}</Link>,
                icon: child.icon
              },
              ...buildMenuItems(child.id) 
            ]
          }
        : {
            key: child.id,
            icon: child.icon,
            label: (
            <Link replace={props.isReplacingCurrentRoute} to={createPath(child.path)}>{child.title}</Link>
          )
          };
    });
  };

  const topMenu = () => {
    const root = pageLayouts.find((x) => x.id === 'ROOT') as any;
    const matchedPages = matchRoutes(pageLayouts as any, location);
    const matchedIds = matchedPages ? matchedPages.map((x: any) => x.route.id.toString()) : [];
 
    return (
      <Menu
        theme={props.theme}
        mode={props.mode}
        defaultSelectedKeys={matchedIds}
        selectedKeys={matchedIds}
        items={[
          {
            key: 'ROOT',
            icon: root.icon,
            label: <Link replace={props.isReplacingCurrentRoute} to={createPath(root.path)}>{root.title}</Link>
          },
          ...buildMenuItems(root.id)
        ]}
        style={{ background: "transparent" }}
      />
    );
  };

  return topMenu();
};
